//配置路由相关信息
import Vue from 'vue'
import VueRouter from 'vue-router'
import _string from "@/utils/_string";
import _config from "../common/_config";

//通过vue.use(插件)，安装插件
Vue.use(VueRouter)

//创建路由对象
const routes = []

//注册路由函数
const _register_rule = function (path,name) {
  //去除间隔符
  let component = _string.trim_separator(path, '/')

  let rule = {}
  rule.path = _config.prefix +path
    rule.name= name
  rule.component = (resolve) => require([`../views/${component}`], resolve)
  routes.push(rule)
}

//注册路由
//首页
_register_rule('/home', 'home')
//资讯
_register_rule('/news','news')
//指导
_register_rule('/guide','guide')
//展会
_register_rule('/expo','expo')

//文章
_register_rule('/info','info')

//未知
routes.push({ path: '*', redirect: _config.prefix + '/home' })

const router = new VueRouter(
    {
      //配置路由和组建之间的应用关系
      mode: 'history',
      base: process.env.BASE_URL,
      routes
    }
)

export default router
